<template>
  <router-view />
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
@font-face {
  font-family: 'KONEInformation';
  src: url('@/fonts/KONE_Information.ttf') format('truetype');
  font-weight: normal;
  font-style: normal;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'KONEInformation', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;
}

/* ── Custom icon CSS variables ──────────────────────────────────────────────
   Used by icons in src/components/icons/ that rely on the CSS-variable pattern
   (e.g. IconRobot.vue).  Set on :root / .theme-dark for dark (default),
   and on .theme-light for the light palette.
   ─────────────────────────────────────────────────────────────────────────── */
:root,
.theme-dark {
  --icon-primary: #e2e8f0;   /* slate-200 — main strokes/fills */
  --icon-accent:  #a78bfa;   /* violet-400 — highlight dots */
}
.theme-light {
  --icon-primary: #1e293b;   /* slate-800 */
  --icon-accent:  #6366f1;   /* indigo-500 */
}
</style>
